<template>
  <div
    v-if="videoDuration >= minVideoDuration"
    class="comp-container__video-slice"
    :class="{
      hide: status === 'hide',
    }"
  >
    <div class="bar" @click="toggleStatus">
      <img
        class="open-btn"
        v-if="status === 'open'"
        src="@saas/pages/assets/images/course-card/arrow.png"
        alt=""
      />
      <img
        class="hide-btn"
        v-else
        src="@saas/pages/assets/images/course-card/arrow.png"
        alt=""
      />
    </div>
    <div class="list-box" v-show="status === 'open'">
      <div class="scroll-box">
        <div
          class="data-item"
          :class="{ active: isReactive(item, index) }"
          :ref="'item' + index"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="top">
            <div class="left" @click="onClickPlay(item)">
              <div class="time">{{ secondsToHms(item.start_second) }}</div>
              <div class="title">{{ item.title }}</div>
            </div>

            <div class="arrow" @click="handleClickArrow(item, index)">
              <img
                v-if="item.isOpen"
                class="show"
                src="@saas/pages/assets/images/course-card/arrow.png"
                alt=""
              />
              <img
                v-else
                src="@saas/pages/assets/images/course-card/arrow.png"
                alt=""
              />
            </div>
          </div>
          <div class="desc" v-if="item.isOpen">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLessonOutline } from "@saas/server-api/src/learning-center";
export default {
  props: {
    lessonInfo: {
      type: Object,
      default: () => {},
    },
    playSecond: {
      type: Number,
      default: 0,
    },
    videoDuration: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    "lessonInfo.id": {
      handler(val) {
        this.initData();
      },
      immediate: true,
    },
  },
  data() {
    return {
      status: "open", // open or hide
      list: [],
      minVideoDuration: 15 * 60, //视频时长在15分钟以上，否则不生成
    };
  },
  mounted() {},
  methods: {
    initData() {
      if (!this.lessonInfo.id) {
        return;
      }
      getLessonOutline({ lesson_id: this.lessonInfo.id })
        .then((res) => {
          if (res.code === 1) {
            const list = res.data?.outline || [];
            this.list = list.map((item) => {
              return {
                ...item,
                isOpen: false,
              };
            });
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {});
    },
    toggleStatus() {
      this.status = this.status === "open" ? "hide" : "open";
    },
    handleClickArrow(item, index) {
      const isOpen = item.isOpen;
      item.isOpen = !isOpen;
      if (!isOpen) {
        this.$nextTick(() => {
          // 滚动到能显示的区域
          this.$refs["item" + index][0].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        });
      }
    },
    // 秒转时分秒比如 00:00:00
    secondsToHms(seconds) {
      const hours = Math.floor(seconds / 3600);
      seconds %= 3600;
      const minutes = Math.floor(seconds / 60);
      seconds %= 60;
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:${String(seconds).padStart(2, "0")}`;
    },
    onClickPlay(item) {
      this.$emit("jumpPlay", item.start_second);
    },
    isReactive(item, index) {
      if (index < this.list.length - 1) {
        // 判断是否正在播放
        return (
          this.playSecond >= item.start_second &&
          this.playSecond < this.list[index + 1].start_second
        );
      } else {
        return this.playSecond >= item.start_second;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container__video-slice {
  width: 352px;
  position: relative;
  transition: width 0.3s ease-in-out;
  &.hide {
    width: 18px;
  }
  .bar {
    width: 18px;
    height: 54px;
    background: rgba(29, 33, 41, 0.9);
    border-radius: 9px;
    opacity: 0.9;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #86909c;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background: rgba(78, 89, 105, 0.9);
    }
    .hide-btn {
      width: 14px;
      height: 8px;
      // 旋转90度
      transform: rotate(90deg);
    }
    .open-btn {
      width: 14px;
      height: 8px;
      // 旋转90度
      transform: rotate(-90deg);
    }
  }
  .list-box {
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0;
    }
    &::-webkit-scrollbar-thumb {
      background: #ffffff;
      border-radius: 1px;
    }
    .scroll-box {
      height: 100%;
      min-height: fit-content;
      display: flex;
      flex-direction: column;

      align-items: flex-end;
      justify-content: center;
      .data-item {
        width: 320px;
        background: rgba(29, 33, 41, 0.9);
        border-radius: 12px;
        margin: 6px 0;
        transition: height 0.3s ease-in-out;
        &:hover {
          background: rgba(78, 89, 105, 0.9);
        }
        &.active {
          .time {
            background: linear-gradient(
              132deg,
              #00eb81 0%,
              #00c89d 100%
            ) !important;
            border-radius: 12px;
            color: #fff !important;
          }
        }
        .top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          min-height: 46px;
          .left {
            cursor: pointer;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 12px 0 12px 8px;
            min-height: 46px;
            .time {
              width: 52px;
              margin-top: 3px;
              height: 16px;
              line-height: 16px;
              background: #c9cdd4;
              border-radius: 12px;
              font-weight: 600;
              font-size: 11px;
              color: #1d2129;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .title {
              font-weight: 500;
              font-size: 16px;
              color: #ffffff;
              line-height: 22px;
              flex: 1;
              margin: 0 3px;
            }
          }
          .arrow {
            width: 28px;
            height: 46px;
            display: flex;
            align-items: center;
            padding-left: 4px;
            cursor: pointer;
            img {
              width: 9px;
              height: 6px;
            }
            .show {
              transform: rotate(180deg);
            }
          }
        }
        .desc {
          padding: 0 8px 8px 8px;
          font-weight: 400;
          font-size: 14px;
          color: #c9cdd4;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
